export const RESET_APP = "RESET_APP";

export function logout() {
  return {
    type: RESET_APP
  };
}
